import { FC } from "react";
import { ProgressCircleConfig } from "./ProgressCircleConfig";

interface ProgressCircleProps {
  percent: number;
  showPercent?: boolean;
  size?: "xxs" | "xs2" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const ProgressCircle: FC<ProgressCircleProps> = ({
  percent,
  showPercent = true,
  size = "xs",
}) => {
  const config = ProgressCircleConfig.circleSizes[size];
  const circumference = 2 * Math.PI * config.radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <div className="flex items-center justify-center relative">
      <svg
        className="transform -rotate-90"
        width={config.size}
        height={config.size}
      >
        {/* Background circle */}
        <circle
          cx={config.center}
          cy={config.center}
          r={config.radius}
          stroke="currentColor"
          strokeWidth={config.strokeWidth}
          fill="transparent"
          className="text-gray-200"
        />

        {/* Progress circle */}
        <circle
          cx={config.center}
          cy={config.center}
          r={config.radius}
          stroke="currentColor"
          strokeWidth={config.strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="text-herb-500"
          style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
        />
      </svg>
      {showPercent && (
        <span
          className={["absolute text-5xl font-bold", config.textSize].join(" ")}
        >
          {percent}%
        </span>
      )}
    </div>
  );
};
